import { render } from "./friendList.vue?vue&type=template&id=31d38ffb"
import script from "./friendList.vue?vue&type=script&lang=js"
export * from "./friendList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__